(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name missingPatternsReport.controller:MissingPatternsReportCtrl
   *
   * @description
   *
   */
  angular
    .module('missingPatternsReport')
    .controller('MissingPatternsReportCtrl', MissingPatternsReportCtrl);

  function MissingPatternsReportCtrl(CommonMasterData,$sce,CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'MissingPatternsReportCtrl';

    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        carriers : null
      },
      masterList : {
        airportList:[],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        fromTimeInvalid : false,
        toTimeInvalid : false,
        carriers : []
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };


    // submit search
    vm.submitSearch = function(params) {
      searchMissingPatternsReport(params);
    };

    // when change field in search
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      // if from date time before to date time
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.toDate
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid
        && !isFromDateBeforeToDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    // validate Date
    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function searchMissingPatternsReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "missing_patterns_report.rptdesign";

        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.toDate) {
        if (vm.model.masterList.toDateFormatInvalid
          || vm.model.masterList.fromDateFormatInvalid
          || vm.model.masterList.fromDateAfterToDate) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    }
    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["carrier"] = '';
      if (!!param.carriers && !!param.carriers.code) {
        searchParamMap["carrier"] = param.carriers.code;
      }

      return searchParamMap;
    }

    (function() {

      CommonMasterData.searchCarriers(
        function (response) {
          for(var index in response.hubCodes) {
            vm.model.masterList.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
          }
          vm.model.defaultCarrier = response.clientCode;
        },
        function (error) {
          MessageService.error(error);
        }
      );

    })();

  }
}());
